// extracted by css-extract-rspack-plugin
export default {"wrapper_edit":"l0lr8duajRgTZtsz","header_edit":"twOkFTxp82Mb4Ddx","title_edit":"Q3uhgdhJvFAhkb9H","editor_table":"eQ2C0XfQleIEk_MR"};